import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

// cn is the standard Tailwind class-merger used across the UI. clsx flattens
// conditional class lists; twMerge resolves duplicate utilities (e.g. so a
// caller's "px-6" overrides a baseline "px-4" cleanly).
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
